/* Storyhorn page script. Runs only on the vf-storyhorn template. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('gc-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  document.body.classList.add('gc-page');

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- state ---------- */
  var colors = [];
  CFG.variants.forEach(function (v) { if (colors.indexOf(v.c) < 0) colors.push(v.c); });
  var state = {
    color: CFG.defaultColor,
    set: CFG.defaultSet,
    color2: colors[1] || CFG.defaultColor,
    addons: {}
  };
  function variant(color, set) {
    color = color || state.color; set = set || state.set;
    for (var i = 0; i < CFG.variants.length; i++) {
      var v = CFG.variants[i];
      if (v.c === color && v.s === set) return v;
    }
    return CFG.variants[0];
  }
  function isKit() { return state.set === CFG.kitSet; }
  function isDuo() { return state.set === CFG.duoSet; }
  function shortName() {
    for (var i = 0; i < CFG.sets.length; i++) if (CFG.sets[i].value === state.set) return CFG.sets[i].short;
    return state.set;
  }
  function total() {
    var t = variant().price;
    if (!isKit()) CFG.addons.forEach(function (a) { if (state.addons[a.id]) t += a.price; });
    return t;
  }

  function render() {
    var v = variant();
    var offer = $('#gc-offer');
    if (offer) {
      offer.classList.toggle('is-single', state.set === CFG.singleSet);
      offer.classList.toggle('is-kit', isKit());
      offer.classList.toggle('is-duo', isDuo());
    }
    $$('[data-gc-set]').forEach(function (b) {
      var on = b.dataset.gcSet === state.set;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      var rv = variant(state.color, b.dataset.gcSet);
      var p = b.querySelector('[data-gc-row-price]'); if (p) p.textContent = money(rv.price);
      var w = b.querySelector('[data-gc-row-was]'); if (w && rv.compare) w.textContent = money(rv.compare);
    });
    $$('[data-gc-color]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.gcColor === state.color ? 'true' : 'false'); });
    $$('[data-gc-color2]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.gcColor2 === state.color2 ? 'true' : 'false'); });
    $$('[data-gc-color-name]').forEach(function (el) { el.textContent = state.color; });
    $$('[data-gc-color2-name]').forEach(function (el) { el.textContent = state.color2; });
    var now = $('[data-gc-price]'); if (now) now.textContent = money(v.price);
    var was = $('[data-gc-was]'); var save = $('[data-gc-save]');
    if (v.compare && v.compare > v.price) {
      if (was) { was.hidden = false; was.textContent = money(v.compare); }
      if (save) { save.hidden = false; save.textContent = 'Save ' + money(v.compare - v.price); }
    } else { if (was) was.hidden = true; if (save) save.hidden = true; }
    $$('.gc-addon').forEach(function (b) { b.setAttribute('aria-pressed', state.addons[b.dataset.addon] ? 'true' : 'false'); });
    $$('[data-gc-total]').forEach(function (el) { el.textContent = money(total()); });
    $$('[data-gc-sticky-name]').forEach(function (el) { el.textContent = shortName(); });
    var vi = $('input[name="id"][data-gc-variant-input]'); if (vi) vi.value = v.id;
  }

  function scrollToOffer() {
    var box = document.getElementById('gc-offer');
    if (box) box.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  }

  $$('[data-gc-set]').forEach(function (b) {
    b.addEventListener('click', function () { state.set = b.dataset.gcSet; render(); });
  });
  $$('[data-gc-select-set]').forEach(function (b) {
    b.addEventListener('click', function () { state.set = b.dataset.gcSelectSet; render(); if (!b.closest('#gc-offer')) scrollToOffer(); });
  });
  $$('[data-gc-color]').forEach(function (b) {
    b.addEventListener('click', function () { state.color = b.dataset.gcColor; render(); showVariantMedia(); });
  });
  $$('[data-gc-color2]').forEach(function (b) {
    b.addEventListener('click', function () { state.color2 = b.dataset.gcColor2; render(); });
  });
  $$('.gc-addon').forEach(function (b) {
    b.addEventListener('click', function () { state.addons[b.dataset.addon] = !state.addons[b.dataset.addon]; render(); });
  });

  /* ---------- cart ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() { var d = drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; }
  function setCount(n) {
    $$('[data-gc-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function fetchCart() { return fetch(CFG.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(path, body) {
    return fetch(CFG.routes.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.text().then(function (t) { var j; try { j = JSON.parse(t); } catch (e) { throw new Error(CFG.strings.error); } if (!r.ok || j.status) throw new Error(j.description || j.message || CFG.strings.error); return j; }); });
  }
  function paintDrawer(j, open, btn) {
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') { if (open) window.location.href = CFG.routes.cart; return; }
    if (j && j.sections) d.renderContents(j);
    if (typeof j.item_count === 'number') d.classList.toggle('is-empty', j.item_count === 0);
    if (open && typeof d.open === 'function' && !d.classList.contains('active')) d.open(btn);
  }
  /* the VIP sheet (when the store shows one) opens first; keep the drawer hidden for a moment so they do not fight */
  function vipFirst() {
    var sheet = document.querySelector('.vf-root'), bag = drawer();
    if (!sheet || !bag || sheet.classList.contains('open')) return;
    var hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
    Object.keys(hide).forEach(function (k) { bag.style.setProperty(k, hide[k], 'important'); });
    var ticks = 0, tm = setInterval(function () {
      if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach(function (k) { bag.style.removeProperty(k); }); }
    }, 100);
  }

  /* the free story-time set follows the Storyhorn: one gift and the gift code while a Storyhorn is in the cart, none without it */
  var syncing = null;
  function syncGifts() {
    if (syncing) return syncing;
    syncing = fetchCart().then(function (cart) {
      var hasMain = cart.items.some(function (i) { return i.product_id === CFG.productId; });
      var code = (CFG.giftCode || '').toUpperCase();
      var codes = (cart.discount_codes || []).map(function (c) { return c.code; });
      var others = codes.filter(function (c) { return c.toUpperCase() !== code; });
      var hasCode = codes.length !== others.length;
      var updates = {}, change = false;
      if (hasMain) {
        CFG.gifts.forEach(function (g) {
          var lines = cart.items.filter(function (i) { return i.variant_id === g.id; });
          if (!lines.length) { updates[g.id] = 1; change = true; }
          lines.forEach(function (l, k) { var want = k === 0 ? 1 : 0; if (l.quantity !== want) { updates[l.key] = want; change = true; } });
        });
      } else {
        var giftIds = CFG.gifts.map(function (g) { return g.id; });
        cart.items.forEach(function (i) { if (giftIds.indexOf(i.variant_id) > -1 || (i.properties && i.properties._gift === 'storyhorn')) { updates[i.key] = 0; change = true; } });
      }
      var wantCode = hasMain && code;
      if (!change && (wantCode ? hasCode : !hasCode)) { setCount(cart.item_count); return cart; }
      var body = { updates: updates, sections: sectionIds(), sections_url: window.location.pathname };
      body.discount = others.concat(wantCode ? [CFG.giftCode] : []).join(',');
      return post('cart/update.js', body).then(function (j) { paintDrawer(j, false); setCount(j.item_count); return j; });
    }).catch(function () { return null; }).then(function (c) { syncing = null; return c; });
    return syncing;
  }

  function cartItems(inCart) {
    var v = variant();
    var main = { id: v.id, quantity: 1 };
    if (isDuo()) { main.properties = {}; main.properties[CFG.colorProp] = state.color2; }
    var items = [main];
    if (!isKit()) CFG.addons.forEach(function (a) { if (state.addons[a.id]) items.push({ id: a.id, quantity: 1 }); });
    CFG.gifts.forEach(function (g) { if (!inCart[g.id]) items.push({ id: g.id, quantity: 1, properties: { _gift: 'storyhorn' } }); });
    return items;
  }

  function addToCart(btn) {
    var errs = $$('[data-gc-error]');
    errs.forEach(function (e) { e.hidden = true; });
    var buttons = $$('[data-gc-add]');
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    return fetchCart().then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
      var d = drawer();
      if (d && d.setActiveElement) d.setActiveElement(btn);
      return fetch(CFG.routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartItems(inCart), sections: sectionIds(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
    }).then(function (res) {
      if (!res.ok || res.body.status) {
        throw new Error(res.body.description || res.body.message || CFG.strings.error);
      }
      vipFirst();
      paintDrawer(res.body, false);
      return syncGifts().then(function (c) {
        return (c && typeof c.item_count === 'number' ? Promise.resolve(c) : fetchCart()).then(function (cc) {
          setCount(cc.item_count);
          paintDrawer({ item_count: cc.item_count }, true, btn);
        });
      });
    }).catch(function (e) {
      var msg = (e && e.message) ? e.message : CFG.strings.error;
      if (CFG.draft && CFG.strings.draft && /variant/i.test(msg)) msg = CFG.strings.draft;
      errs.forEach(function (el) { el.textContent = msg; el.hidden = false; });
      if (btn && !btn.closest('#gc-offer')) scrollToOffer();
    }).then(function () {
      buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
    });
  }
  $$('[data-gc-add]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (b.dataset.gcAddSet) { state.set = b.dataset.gcAddSet; render(); }
      addToCart(b);
    });
  });
  $$('[data-gc-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var d = drawer();
      if (!d || typeof d.open !== 'function') return;
      e.preventDefault();
      Promise.all([fetch(CFG.routes.root + '?sections=' + sectionIds().join(',')).then(function (r) { return r.json(); }), fetchCart()]).then(function (res) {
        d.renderContents({ id: 0, sections: res[0] });
        paintDrawer({ item_count: res[1].item_count }, true, b);
      }).catch(function () { d.open(b); });
    });
  });
  syncGifts();
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { clearTimeout(window.__gcSync); window.__gcSync = setTimeout(syncGifts, 300); });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('cart-remove-button, .quantity__button')) setTimeout(syncGifts, 1400);
  });
  /* make sure the gift code is on the cart before checkout */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer [name="checkout"], cart-drawer a[href$="/checkout"]');
    if (!b || b.dataset.gcReady === '1') return;
    e.preventDefault(); e.stopImmediatePropagation();
    syncGifts().then(function () { var n = document.querySelector('cart-drawer [name="checkout"]') || b; n.dataset.gcReady = '1'; n.click(); delete n.dataset.gcReady; });
  }, true);
  /* the shared reviews row puts a comma between the two names; this page joins them with a space */
  $$('.gc-buy__proofrow .ceyla-rproof__text').forEach(function (p) {
    Array.prototype.forEach.call(p.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; });
  });

  /* ---------- gallery ---------- */
  var track = $('.gc-gallery__track');
  var slides = track ? $$('.gc-gallery__slide', track) : [];
  var thumbs = $$('.gc-thumb');
  var current = 0;
  function go(i, smooth) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduced ? 'smooth' : 'auto' });
  }
  function mark(i) {
    current = i;
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var t = thumbs[i];
    if (t && t.parentNode) {
      var p = t.parentNode;
      var left = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
      p.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
    }
    slides.forEach(function (s, k) {
      var v = s.querySelector('video');
      if (!v) return;
      if (k === i) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); }
    });
  }
  function showVariantMedia() {
    var v = variant();
    if (!v.media) return;
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].dataset.mediaId) === String(v.media)) { go(i, true); mark(i); return; }
    }
  }
  if (track) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) mark(i);
        ticking = false;
      });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i, true); mark(i); }); });
    var prev = $('.gc-gallery__nav--prev'), next = $('.gc-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    mark(0);
  }

  /* ---------- shipping dates (local calendar days) ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function fmtRange(a, b) { return a.getMonth() === b.getMonth() ? fmt(a) + '-' + b.getDate() : fmt(a) + ' - ' + fmt(b); }
  var lastDay = '';
  function dates() {
    var now = new Date();
    var key = now.toDateString();
    if (key === lastDay) return; lastDay = key;
    var s = CFG.ship;
    var shipped = addDays(now, s.ship), d1 = addDays(now, s.min), d2 = addDays(now, s.max);
    $$('[data-gc-date="order"]').forEach(function (el) { el.textContent = fmt(now); });
    $$('[data-gc-date="ship"]').forEach(function (el) { el.textContent = fmt(shipped); });
    $$('[data-gc-date="deliver"]').forEach(function (el) { el.textContent = fmtRange(d1, d2); });
    /* gift deadline: last order day whose latest delivery still lands by Dec 24 */
    $$('[data-gc-deadline]').forEach(function (dl) {
      var eve = new Date(now.getFullYear(), 11, 24);
      var last = addDays(eve, -s.max);
      if (now <= last) {
        dl.hidden = false;
        var t = dl.querySelector('[data-gc-deadline-date]'); if (t) t.textContent = fmt(last);
      } else { dl.hidden = true; }
    });
  }
  dates();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) dates(); });
  window.addEventListener('pageshow', dates);
  setInterval(dates, 60000);

  /* ---------- dialog ---------- */
  $$('[data-gc-dialog]').forEach(function (b) {
    b.addEventListener('click', function () {
      var dlg = document.getElementById(b.dataset.gcDialog);
      if (dlg && dlg.showModal) dlg.showModal();
    });
  });
  $$('.gc-dialog').forEach(function (dlg) {
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var x = dlg.querySelector('.gc-dialog__x'); if (x) x.addEventListener('click', function () { dlg.close(); });
  });

  /* ---------- sticky bar and sample pill ---------- */
  var mainAtc = $('.gc-atc');
  var sticky = $('.gc-sticky');
  var closeSec = $('.gc-close');
  if (mainAtc && sticky && 'IntersectionObserver' in window) {
    var atcVisible = true, closeVisible = false;
    var upd = function () { sticky.classList.toggle('is-on', !atcVisible && !closeVisible && mainAtc.getBoundingClientRect().top < 0); };
    new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; upd(); }).observe(mainAtc);
    if (closeSec) new IntersectionObserver(function (en) { closeVisible = en[0].isIntersecting; upd(); }).observe(closeSec);
    window.addEventListener('scroll', function () { if (!atcVisible) upd(); }, { passive: true });
  }
  var banner = $('.gc-disclose'), pill = $('.gc-pill');
  if (banner && pill && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { pill.classList.toggle('is-on', !en[0].isIntersecting); }).observe(banner);
  }

  /* ---------- demo: drop a card ---------- */
  $$('.gc-demo').forEach(function (demo) {
    var stage = $('.gc-stage', demo);
    var card = $('.gc-stage__card', demo);
    var cardImg = card ? card.querySelector('img') : null;
    var title = $('[data-gc-now-title]', demo), sub = $('[data-gc-now-sub]', demo);
    var picks = $$('.gc-pick', demo);
    if (!stage || !card || !cardImg || !picks.length) return;
    var timer = null;
    var drop = function (p) {
      picks.forEach(function (x) { x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
      clearTimeout(timer);
      stage.classList.remove('is-playing');
      card.classList.remove('is-drop', 'is-play');
      card.hidden = false;
      cardImg.src = p.dataset.img;
      cardImg.alt = p.dataset.title || '';
      if (title) title.textContent = p.dataset.title || '';
      if (sub) sub.textContent = p.dataset.sub || '';
      void card.offsetWidth;
      if (reduced) { stage.classList.add('is-playing'); return; }
      card.classList.add('is-drop');
      timer = setTimeout(function () { card.classList.remove('is-drop'); card.classList.add('is-play'); stage.classList.add('is-playing'); }, 560);
    };
    picks.forEach(function (p) { p.addEventListener('click', function () { drop(p); }); });
    var first = picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; })[0] || picks[0];
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect(); drop(first);
      }, { threshold: .45 });
      io.observe(stage);
    } else { drop(first); }
  });

  /* ---------- reveals (content stays visible without JS) ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('gc-js');
    var rio = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); rio.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.gc-reveal').forEach(function (el) { rio.observe(el); });
    setTimeout(function () { $$('.gc-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
  }

  render();
})();
